import { RootState } from './root.reducer';

import { initialDataEditorState } from 'modules/data-editor/redux';
import { initialSessionState } from 'modules/session-management/redux';
import { initialUserState } from 'modules/user-management/redux';
import { initialDownloadTemplateState } from '../download-template';
import { initialMasterDataState } from 'modules/master-data/redux';
import { initialPreviewDataState } from '../preview-data';
import { initialAppState } from '../app-state';
import { initialFileUploadState } from '../file-upload';
import { initialConfigurationState } from 'modules/configuration/redux';
import { initialArchiveState } from 'modules/archive/redux';
import { initialUserState as initialAppUserState } from '../user';
import { initialEntityState } from '../entity';
import { initialSyncHistoryState } from 'modules/sync-history/redux';
import { initialDataManagementState } from 'modules/data-management/redux';

const initialState: RootState = {
    session: initialSessionState,
    user: initialUserState,
    dataEditor: initialDataEditorState,
    downloadTemplate: initialDownloadTemplateState,
    masterData: initialMasterDataState,
    previewData: initialPreviewDataState,
    appState: initialAppState,
    fileUpload: initialFileUploadState,
    configurationData: initialConfigurationState,
    archive: initialArchiveState,
    appUser: initialAppUserState,
    entity: initialEntityState,
    syncHistory: initialSyncHistoryState,
    dataManagement: initialDataManagementState
};

export type InitialStoreState = any;

export default initialState;
